<label class="mb-1">{{ "common.dateSelector.label" | translate }}</label>
<form class="d-flex range-selection">
  <!-- Hidden datepicker for custom template -->
  <div class="form-group hidden">
    <div class="input-group">
      <input
        name="datepicker"
        class="form-control"
        ngbDatepicker
        #startDatePicker="ngbDatepicker"
        [autoClose]="'outside'"
        (dateSelect)="onDateSelection($event, startDatePicker)"
        [displayMonths]="2"
        [dayTemplate]="t"
        [footerTemplate]="startDateFooter"
        outsideDays="hidden"
        [startDate]="startDate!"
      />

      <ng-template #t let-date let-focused="focused">
        <span
          class="custom-day"
          [class.focused]="focused"
          [class.range]="isRange(date)"
          [class.faded]="isHovered(date) || isInside(date)"
          (mouseenter)="hoveredDate = date"
          (mouseleave)="hoveredDate = null"
        >
          {{ date.day }}
        </span>
      </ng-template>

      <!-- Footer template for start datepicker with Today button -->
      <ng-template #startDateFooter>
        <div class="d-flex justify-content-center p-2">
          <button
            type="button"
            class="btn btn-sm btn-primary"
            (click)="selectToday(startDatePicker, 'start')"
          >
            Today
          </button>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- Start date input -->
  <div class="mx-2 ms-0">
    <div class="input-group" (click)="startDatePicker.toggle()">
      <input
        #dpstartDate
        class="form-control"
        placeholder="yyyy-mm-dd"
        name="dpstartDate"
        [value]="formatter.format(startDate)"
        (input)="startDate = validateInput(startDate, dpstartDate.value)"
      />
      <button class="input-group-text" type="button">
        <i class="feather icon-calendar icon-md text-muted"></i>
      </button>
    </div>
  </div>

  <!-- Hidden datepicker for custom template -->
  <div class="form-group hidden">
    <div class="input-group">
      <input
        name="datepicker"
        class="form-control"
        ngbDatepicker
        #endDatePicker="ngbDatepicker"
        [autoClose]="'outside'"
        (dateSelect)="onDateSelection($event, endDatePicker)"
        [displayMonths]="2"
        [dayTemplate]="t"
        [footerTemplate]="endDateFooter"
        outsideDays="hidden"
        [startDate]="startDate!"
      />

      <!-- Footer template for end datepicker with Today button -->
      <ng-template #endDateFooter>
        <div class="d-flex justify-content-center p-2">
          <button
            type="button"
            class="btn btn-sm btn-primary"
            (click)="selectToday(endDatePicker, 'end')"
          >
            Today
          </button>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- End date input -->
  <div>
    <div class="input-group" (click)="endDatePicker.toggle()">
      <input
        #dpendDate
        class="form-control"
        placeholder="yyyy-mm-dd"
        name="dpendDate"
        [value]="formatter.format(endDate)"
        (input)="endDate = validateInput(endDate, dpendDate.value)"
      />
      <button class="input-group-text" type="button">
        <i class="feather icon-calendar icon-md text-muted"></i>
      </button>
    </div>
  </div>
</form>
